// extracted by mini-css-extract-plugin
export var button = "ContentfulSharedImageText-module--button--2d16f";
export var youTubeIFrame = "ContentfulSharedImageText-module--youTubeIFrame--7fae1";